import AdminApi from '../../services/api'
import SonOffApi from '../../services/apiSonoff'
import swal from 'sweetalert2';
import session from "../../services/session";
import CONFIG_COMPANY from "../../services/myConfig";
import Loc from "../../services/localization";

const AdminApiService = new AdminApi()
const SonOffApiService = new SonOffApi()
const LocService = new Loc()

export default {
    data() {
        return {
            locale: LocService,
            role: '',
            username: '',
            orders: [],
            userWallets: [],
            selectedButton: 'USER_WALLETS',
            fromDate : null,
            toDate: null,
            filter: '',
            pagination: {
                page: 1,
                limit: 100,
                totalCount: 0
            },
            useProfilePictures: false,
            showImagePreview: false,
            imageToPreviewUserId: 0,
            imageToPreview: "",
        }
    },
    methods: {
        load: load,
        clickSearch: clickSearch,
        cancelOrder: cancelOrder,
        loadOrders: loadOrders,
        setUserWalletPaid: setUserWalletPaid,
        loadUserWallets: loadUserWallets,
        onTabClicked: onTabClicked,
        openImage: openImage,
        formatDateAndTime: formatDateAndTime,
        keymonitor: keymonitor,
        listener(){
           this.load();
        },

    },

    beforeMount() {
        if (session.getRole() !== 'ROLE_ADMIN' && session.getRole() !== 'ROLE_SUPER_ADMIN' && session.getRole() !== 'ROLE_USER') {
            this.$router.push(CONFIG_COMPANY.HOME);
            return;
        }
        this.role = session.getRole();
        this.username = session.getUsername();
        this.fromDate = this.$moment(new Date()).format('YYYY-MM-DD')
        this.toDate = this.$moment(new Date()).format('YYYY-MM-DD')
        this.useProfilePictures = session.getConfig().useProfilePictures == null ? true : session.getConfig().useProfilePictures;
        this.loadOrders()
        this.loadUserWallets()
    },
    created() {
        let _self = this;
        this.$topnavbar.$on('closeShowImage', () => {
            _self.showImagePreview = false;
        });
        this.$trainingBus.$on('refreshEntrance', this.listener);
    },
    beforeDestroy() {
        this.$trainingBus.$off('refreshEntrance', this.listener)
    },
    watch: {
        'filter': function (newVal) {
            if (newVal.length === 0){
                this.pagination.page = 1;
                this.load()
            }
        }
    }
}

function openImage(image, userId){
    this.imageToPreview = image;
    this.imageToPreviewUserId = userId;
    this.showImagePreview = true;
}

function clickSearch() {
    this.pagination.page = 1;
    this.load()
}


function onTabClicked(data){
    this.selectedButton = data
    this.clickSearch();
}


function load() {
    if(this.selectedButton === 'ORDERS'){
        this.loadOrders();
    }else{
        this.loadUserWallets();
    }

}
function loadOrders(){
    let _self = this
    var model = {
        fromDate : _self.$moment(_self.fromDate).format('DD-MM-YYYY'),
        toDate : _self.$moment(_self.toDate).format('DD-MM-YYYY'),
        page: _self.pagination.page,
        limit: _self.pagination.limit,
        filter: _self.filter,
    }
    AdminApiService.getAdminOrders(model)
        .then((response) => {
            _self.orders = response.data.results;
            _self.pagination.totalCount = response.data.totalCount;
        })
        .catch(error => {
            swal(LocService.t("label_error"), error.data.localized_error_message, 'error')
        })
}

function loadUserWallets(){
    let _self = this
    var model = {
        fromDate : _self.$moment(_self.fromDate).format('DD-MM-YYYY'),
        toDate : _self.$moment(_self.toDate).format('DD-MM-YYYY'),
        page: _self.pagination.page,
        limit: _self.pagination.limit,
        filter: _self.filter,
    }
    AdminApiService.getAdminUserWallets(model)
        .then((response) => {
            _self.userWallets = response.data.results;
            _self.pagination.totalCount = response.data.totalCount;
        })
        .catch(error => {
            swal(LocService.t("label_error"), error.data.localized_error_message, 'error')
        })
}

function keymonitor(event) {
    if (event.key === 'Enter') {
        this.pagination.page = 1;
        this.load();
    }
}

function formatDateAndTime(date) {
    return this.$moment(new Date(date * 1000)).format('DD-MM-YYYY HH:mm')
}

function cancelOrder(item){
    let _self = this;
    swal({
        title: LocService.t('label_are_you_sure'),
        text: LocService.t('label_are_you_sure_cancel_order') + item.name +" ?",
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: LocService.t('label_no'),
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: LocService.t('label_yes'),
        customClass: 'swal2-warning'
    }).then(function () {
        AdminApiService.deleteOrder(item.id)
            .then((response) => {
                swal(LocService.t('label_success'), LocService.t('label_order_canceled_successfully'), 'success')
                _self.load();
            })
            .catch((error) => {
                swal(LocService.t('label_error'), error.data.localized_error_message, 'error')
            })
    });
}


function setUserWalletPaid(item){
    let _self = this;
    swal({
        title: LocService.t('label_are_you_sure'),
        text: LocService.t('label_are_you_sure_pay_user_wallet') + item.name +" ?",
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: LocService.t('label_no'),
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: LocService.t('label_yes'),
        customClass: 'swal2-warning'
    }).then(function () {
        AdminApiService.setPaidUserWallet(item.id, true)
            .then((response) => {
                swal(LocService.t('label_success'), LocService.t('label_user_wallet_paid_successfully'), 'success')
                _self.load();
            })
            .catch((error) => {
                swal(LocService.t('label_error'), error.data.localized_error_message, 'error')
            })
    });
}


// WEBPACK FOOTER //
// ./src/components/Order/Orders.js